import { render, staticRenderFns } from "./ModaMedia.vue?vue&type=template&id=899a951c"
import script from "./ModaMedia.vue?vue&type=script&lang=js"
export * from "./ModaMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports